import {Box, Button, Grid, Tooltip, Typography} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import React from "react";
import handleDeleteForm from "../../helpers/HandleDeleteForm";
import handleArchiveForm from "../../helpers/HandleArchiveForm";
import {useHandleGetListForm} from "../../helpers/HandleGetListForm";
import {useLoading} from "../../Context/LoadingContext";
import handleUnArchiveForm from "../../helpers/HadleUnarchiveForm";

const MainNavbarButtonAction = ({selectDrawerItem , listId }) => {

    const { fetchList } = useHandleGetListForm();
    const { setLoading } = useLoading();

    return(
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Grid display={selectDrawerItem === 'Trash' || selectDrawerItem === 'Archive' ? 'none' : 'block'}>
                <Tooltip title={<Typography variant='subtitle1'>حذف</Typography>} arrow>
                    <Button variant='outlined' color='error' style={{ width: '40px', height: '40px' }} onClick={()=>{handleDeleteForm(listId, fetchList , setLoading)}}>
                        <DeleteIcon style={{ color: '#B80000', width: '20px', height: '20px' }} />
                    </Button>
                </Tooltip>
            </Grid>
            <Grid display={selectDrawerItem === 'Trash' || selectDrawerItem === 'Archive' ? 'none' : 'block'}>
                <Tooltip title={<Typography variant='subtitle1'>بایگانی</Typography>} arrow>
                    <Button variant='outlined' color='primary' style={{ width: '40px', height: '40px' }} onClick={()=>{handleArchiveForm(listId, fetchList , setLoading)}}>
                        <ArchiveIcon style={{ color: '#478CCF', width: '20px', height: '20px' }} />
                    </Button>
                </Tooltip>
            </Grid>
            <Grid display={selectDrawerItem === 'Archive' ? 'block' : 'none'}>
                <Tooltip title={<Typography variant='subtitle1'>خروج از آرشیو</Typography>} arrow>
                    <Button variant='outlined' color='secondary' style={{ width: '40px', height: '40px' }} onClick={()=>{handleUnArchiveForm(listId, fetchList , setLoading)}}>
                        <UnarchiveIcon style={{ color: '#7469B6', width: '20px', height: '20px' }} />
                    </Button>
                </Tooltip>
            </Grid>
            <Grid className='DeleteRemove' display={selectDrawerItem === 'Trash' || selectDrawerItem === 'Archive' ? 'block' : 'none'}>
                <Tooltip title={<Typography variant='subtitle1'>حذف</Typography>} arrow>
                    <Button variant='contained' color='error' style={{ width: '40px', height: '40px' }} onClick={()=>{handleDeleteForm(listId, fetchList , setLoading)}}>
                        <DeleteIcon style={{ color: 'white', width: '20px', height: '20px' }} />
                    </Button>
                </Tooltip>
            </Grid>
        </Box>
    )
}


export default MainNavbarButtonAction;